import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { CSVInterface, InteractionType, InteractionTypeStatus } from '@interfaces'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class InteractionTypesService implements CSVInterface {
	private http = inject(HttpClient)
	private _creatingTask: boolean = false
	private creatingTaskSubject = new BehaviorSubject<boolean>(false)
	creatingInteractionType$ = this.creatingTaskSubject.asObservable()
	private _creatingTaskStatus: boolean = false
	private creatingTaskStatusSubject = new BehaviorSubject<boolean>(false)
	creatingTaskStatus$ = this.creatingTaskStatusSubject.asObservable()
	url = '/opportunities/interactionsType'

	interactionTypes: InteractionType[]

	// Obtiene todos los tipos de interacción
	getInteractionTypes(): Observable<InteractionType[]> {
		return this.http.get<InteractionType[]>(`${this.url}`)
	}

	// Habilita/dehabilita un tipo de interacción (solo se pueden las del sistema, CALL y VISIT)
	putInteractionType(
		idInteractionType: number,
		enabled: boolean | null,
		interactionType: InteractionType | null
	): Observable<InteractionType> {
		return this.http.put<InteractionType>(`${this.url}/${idInteractionType}?enabled=${enabled}`, interactionType)
	}

	// Hace el recuento de las interacciones asignadas a los tipos de interacción que deseamos eliminar
	countAssignedInteractions(interactionTypesIds: { id: number }[]) {
		return this.http.post<number>(`/opportunities/opportunities/interactions/count`, interactionTypesIds)
	}

	// Crea ua tarea si no existe, en caso contrario, la edita
	createOrUpdateTask(data: InteractionType): Observable<InteractionType> {
		return this.http.post<InteractionType>(`${this.url}`, data)
	}

	// Crea un estado de tarea si no existe, en caso contrario, lo edita
	createTaskStatus(data: InteractionTypeStatus, idInteractionType: number): Observable<InteractionTypeStatus> {
		return this.http.put<InteractionTypeStatus>(`${this.url}/${idInteractionType}`, data)
	}

	// Edita el nombre de un estado de tarea
	putTaskStatusName(idTypeStatus: number, name: string): Observable<InteractionTypeStatus> {
		return this.http.put<InteractionTypeStatus>(`${this.url}/typeStatus/${idTypeStatus}?name=${name}`, null)
	}

	// Asigna un usuario o perfil (en función del tipo) a un estado de tarea
	putTaskStatusUser(idTypeStatus: number, id: number, type: string): Observable<InteractionTypeStatus> {
		let url = `${this.url}/typeStatus/${idTypeStatus}?`
		url += type === 'u' ? `idUser=${id}` : `idProfile=${id}`
		return this.http.put<InteractionTypeStatus>(url, {})
	}

	// Elimina por completo una tarea
	delete(taskList: { id: number }[], accept: boolean): Observable<void> {
		const deactivationType = accept ? 'KEEP' : 'DELETION'
		return this.http.delete<void>(`${this.url}?deactivationType=${deactivationType}`, { body: taskList })
	}

	// Elimina un estado de tarea
	deleteTaskStatus(interactionTypeId: number, id: number): Observable<void> {
		return this.http.delete<void>(`${this.url}/${interactionTypeId}/typeStatus/${id}`)
	}

	// Obtiene la plantilla en formato CSV para la importación de tareas
	templateCSV() {
		const headers = new HttpHeaders({
			'Content-Type': 'text/csv',
			responseType: 'blob',
			Accept: 'text/csv',
			observe: 'response'
		})
		return this.http.get(`${this.url}/importTemplate`, { headers, responseType: 'text' })
	}

	// Sube un archivo CSV con las tareas a importar
	uploadCSV(file: File) {
		const formData = new FormData()
		formData.append('file', file, file.name)

		return this.http.post<InteractionType[]>(`${this.url}/import`, formData, { observe: 'response' })
	}

	// Obtiene un excel con las tareas a exportar
	export(taskList: { id: number }[]): Observable<HttpResponse<Blob>> {
		return this.http.post<Blob>(`${this.url}/export`, taskList, { observe: 'response', responseType: 'blob' as 'json' })
	}

	// Reordena los estados de una tarea
	reorderTaskStatus(taskId: number, taskStatusId: number, newOrder: number) {
		return this.http.post<InteractionTypeStatus>(
			`${this.url}/${taskId}/typeStatus/${taskStatusId}/reorder?newOrder=${newOrder}`,
			null
		)
	}

	// Marca el estado de creación de tarea como false
	resetCreatingTask() {
		this._creatingTask = false
		this.creatingTaskSubject.next(this._creatingTask)
	}

	// Alterna el estado de creación de tarea
	toogleCreatingTask() {
		this._creatingTask = !this._creatingTask
		this.creatingTaskSubject.next(this._creatingTask)
	}

	// Marca el estado de creación del estado de una tarea como false
	resetCreatingTaskStatus() {
		this._creatingTaskStatus = false
		this.creatingTaskStatusSubject.next(this._creatingTaskStatus)
	}

	// Alterna el estado de creación del estado de una tarea
	toogleCreatingTaskStatus() {
		this._creatingTaskStatus = !this._creatingTaskStatus
		this.creatingTaskStatusSubject.next(this._creatingTaskStatus)
	}
}
